import { HttpContextToken } from "@angular/common/http";

export const USE_ALT_TOKEN = new HttpContextToken<boolean>(() => false);